// src/hooks/useCities.js
import { graphql, useStaticQuery } from 'gatsby';

export const useCities = () => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulCities {
        nodes {
          cityname
          keywords
          metaDescription
          metaTitle
          title
          types
          otherinfotitle
          img {
            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
          }
          desc {
            desc
          }
          desc1 {
            desc1
          }
          additionalInfotitle
          additionalInfo {
            description
          }
          otherinfo {
            listing
          }
          icon {
            gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
          }
        }
      }
    }
  `);

  return data.allContentfulCities.nodes;
};
